import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { InfoCircleFill } from 'react-bootstrap-icons';
import { isFileStructureShowing } from '../actions/actionCreator';
import { helpLink } from '../assets/js/tooltips.js';

const mapStateToProps = (state) => ({
  showingFolders: state.isFileStructureShowing,
});

const mapDispatchToProps = (dispatch) => ({
  isFileStructureShowing: (bool) => dispatch(isFileStructureShowing(bool)),
});

class Header extends React.Component {
  render() {
    return (
      <div className="header">
        {this.props.site !== '' && (
          <Button
            id="hideFolders"
            variant="light"
            onClick={() => this.props.isFileStructureShowing(!this.props.showingFolders)}
          >
            {this.props.showingFolders ? 'Hide Folder Column' : 'Show Folder Column'}
          </Button>
        )}
        {this.props.site !== '' && (
          <div className="logo">
            <a className="help" href={helpLink} target="_blank" rel="noreferrer">
              <InfoCircleFill size={27} />
              <span className="help-text">Help</span>
            </a>
            <img src={this.props.image} className="App-logo" alt="logo" />
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);
